import {
    SAVE_CONNECTED_CLIENTS_GRAPH,
    CONNECTED_CLIENTS_GRAPH_API_LOADING
} from '../../constants/graphConstants/connectedClientsGraphConstants';

/**
 * Reducer function for managing hiSenese graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const connectedClientsGraphReducer = (state = {
    loading: false, 
    connectedClients : [], 
    yAxisLabels : [], 
    clientCount : [],
    connectedClientError : null
}, action) => {
	switch (action.type) {
		case SAVE_CONNECTED_CLIENTS_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case CONNECTED_CLIENTS_GRAPH_API_LOADING:
            return { 
                ...state,
                connectedClients : [], 
                yAxisLabels : [], 
                clientCount : [],
                loading: action.payload, 
                connectedClientError: null
            };
		default:
			return state;
	}
};